export default {
  path: 'dashboards',
  name: 'dashboards',
  component: () => import('@/views/dashboards/index.vue'),
  meta: {
    locale: '报表',
    requiresAuth: true,
    icon: 'icon-dashboard',
  },
  children: [
    {
      path: 'dashboard-gtv',
      name: 'dashboard-gtv',
      component: () => import('@/views/dashboards/gtv/index.vue'),
      meta: {
        locale: 'GTV',
        requiresAuth: true,
        roles: ['super', 'admin'],
      },
    },
    // {
    //   path: 'dashboard-recharge',
    //   name: 'dashboard-recharge',
    //   component: () => import('@/views/dashboards/recharge/index.vue'),
    //   meta: {
    //     locale: '充值报表',
    //     requiresAuth: true,
    //     roles: ['super', 'admin'],
    //   },
    // },
    // {
    //   path: 'dashboard-cacheout',
    //   name: 'dashboard-cacheout',
    //   component: () => import('@/views/dashboards/cacheout/index.vue'),
    //   meta: {
    //     locale: '提现报表',
    //     requiresAuth: true,
    //     roles: ['super', 'admin'],
    //   },
    // },
    // /** simple */
    // {
    //   path: 'dashboard-monitor',
    //   name: 'dashboard-monitor',
    //   component: () => import('@/views/dashboards/monitor/index.vue'),
    //   meta: {
    //     locale: 'menu.dashboard.monitor',
    //     requiresAuth: true,
    //     roles: ['super'],
    //   },
    // },
    /** simple end */
  ],
};
